import { connect } from 'react-redux';

import {
  getSecondHandBoardgame,
  createBoardgame,
  updateBoardgame,
} from '../actions/secondHandBoardgames';

import { boardgameSelector } from '../reducers/secondHandBoardgames';

import { isLoadingSelector } from '../reducers';

import AdminSecondHandBoardgamePageComponent from '../components/AdminSecondHandBoardgamePage';
import { withParams } from '../utilities/reactRouter'

const mapStateToProps = (state, ownProps) => {
  return {
    loading: isLoadingSelector(state),
    boardgame: boardgameSelector(state)(ownProps.params.id),
  };
};

const mapDispatchToProps = dispatch => {
  return { 
    createBoardgame: (bg) => dispatch(createBoardgame(bg)),
    getBoardgame: (id) => dispatch(getSecondHandBoardgame(id)),
    updateBoardgame: (id, bg) => dispatch(updateBoardgame(id, bg)),
  };
};

const AdminSecondHandBoardgamePage = withParams(
  connect(mapStateToProps, mapDispatchToProps)(AdminSecondHandBoardgamePageComponent)
);

export default AdminSecondHandBoardgamePage;
